/*
 *
 * ReportHeader constants
 *
 */

export const GET_MEDITIONS_WATCHER = "app/ReportHeader/GET_MEDITIONS_WATCHER"
export const GET_MEDITIONS_SUCCESS = "app/ReportHeader/GET_MEDITIONS_SUCCESS"
export const GET_MEDITIONS_FAILED = "app/ReportHeader/GET_MEDITIONS_FAILED"

export const SET_CURRENT_MEDITION = "app/ReportHeader/SET_CURRENT_MEDITION"

export const OFFICIALIZE_MEDITIONS_WATCHER =
  "app/ReportHeader/OFFICIALIZEMEDITIONS_WATCHER"
export const OFFICIALIZE_MEDITIONS_SUCCESS =
  "app/ReportHeader/OFFICIALIZE_MEDITIONS_SUCCESS"
export const OFFICIALIZE_MEDITIONS_FAILED =
  "app/ReportHeader/OFFICIALIZE_MEDITIONS_FAILED"

export const MEDITIONS_ACTIONS_WATCHER =
  "app/ReportHeader/MEDITIONS_ACTIONS_WATCHER"
export const MEDITIONS_ACTIONS_SUCCESS =
  "app/ReportHeader/MEDITIONS_ACTIONS_SUCCESS"
export const MEDITIONS_ACTIONS_FAILED =
  "app/ReportHeader/MEDITIONS_ACTIONS_FAILED"
